import { DesktopMainFrame } from "@/desktop/components/DesktopMainFrame";
import { Typography } from "@mui/material";

export function DesktopVacationPage() {
    return <DesktopMainFrame>
        <Typography>
            DesktopVacationPage
        </Typography>
    </DesktopMainFrame>;
}